export const TYPE_PROPS = ['Order', 'Bonus', 'Prime', 'Notation', 'Multiplier'];

export const ORDER_VARIANT_PROPS = {
  BUY: ['BUY', 'Buy', 'buy'],
  SELL: ['SELL', 'Sell', 'sell'],
};
